import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Games from './pages/Games';
import TeamsPage from './pages/TeamsPage';
import CareersPage from './pages/CareersPage';
import About from './pages/About';
import TaylorPortfolio from './pages/TaylorPortfolio';
import RenaPortfolio from './pages/RenaPortfolio';


function PageTransition({ children }) {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [displayLocation, setDisplayLocation] = useState(location);

  useEffect(() => {
    if (location !== displayLocation) {
      setIsLoading(true);
    }
  }, [location, displayLocation]);

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setDisplayLocation(location);
        setIsLoading(false);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [isLoading, location]);

  return (
    <>
      {isLoading && (
        <div className="page-loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <div className={`page-content ${isLoading ? 'page-fade-out' : 'page-fade-in'}`}>
        {children}
      </div>
    </>
  );
}

function AppContent() {
  return (
    <div className="App">
      <Navbar />
      <PageTransition>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<Games />} />
          <Route path="/team" element={<TeamsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/taylor" element={<TaylorPortfolio />} />
          <Route path="/rena" element={<RenaPortfolio />} />
        </Routes>
      </PageTransition>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
